var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaitingPaymentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3691 23.9L14.7061 21.389L12.0421 23.214L9.37614 21.388L6.71014 23.212L4.03914 21.386L0.369141 23.9V3C0.369141 2.20435 0.685211 1.44129 1.24782 0.87868C1.81043 0.31607 2.57349 0 3.36914 0L15.3691 0C16.1648 0 16.9279 0.31607 17.4905 0.87868C18.0531 1.44129 18.3691 2.20435 18.3691 3V23.9ZM4.03914 18.962L6.70914 20.788L9.37614 18.962L12.0421 20.788L14.7071 18.961L16.3691 20.1V3C16.3691 2.73478 16.2638 2.48043 16.0762 2.29289C15.8887 2.10536 15.6344 2 15.3691 2H3.36914C3.10392 2 2.84957 2.10536 2.66203 2.29289C2.4745 2.48043 2.36914 2.73478 2.36914 3V20.1L4.03914 18.962Z",
    fill: "#BABABA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3691 7.72412H4.36914V9.72412H14.3691V7.72412Z",
    fill: "#BABABA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3691 11.7241H4.36914V13.7241H12.3691V11.7241Z",
    fill: "#BABABA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingPaymentIcon);
export default __webpack_public_path__ + "static/media/waitingPaymentIcon.b7bcfaa6c9781958c22529aa8cf16cca.svg";
export { ForwardRef as ReactComponent };